/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';

import { RefReturnType, RegisterType } from '../../types/CommonTypes';
import { InputWrapper, Measurement, Wrapper } from './Input.styles';

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  className?: string;
  customValidation?: (string) => boolean;
  defaultValue?: string | number;
  disabled?: boolean;
  inputMaxLength?: string;
  measurement?: string;
  name?: string;
  onChange?: (e) => void;
  pattern?: string;
  placeholder?: string;
  max?: number;
  maxDate?: string;
  min?: number;
  readOnly?: boolean;
  register?: ({
    max,
    maxLength,
    min,
    minLength,
    required,
    validate,
  }: RegisterType) => RefReturnType;
  small?: boolean;
  step?: string;
  type?:
    | 'text'
    | 'datetime-local'
    | 'date'
    | 'email'
    | 'password'
    | 'tel'
    | 'number';
  [x: string]: unknown;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      customValidation,
      defaultValue,
      disabled = false,
      inputMaxLength,
      max,
      maxDate,
      maxLength,
      min,
      minLength,
      measurement,
      name,
      onChange,
      pattern,
      placeholder,
      readOnly = false,
      register,
      required,
      small = false,
      step,
      type,
      ...props
    }: InputProps,
    ref
  ): JSX.Element => {
    return (
      <Wrapper>
        <InputWrapper
          className={className}
          defaultValue={defaultValue}
          disabled={disabled}
          id={name}
          max={maxDate}
          maxLength={inputMaxLength}
          measurement={measurement}
          min={min}
          name={name}
          onChange={onChange}
          pattern={pattern}
          placeholder={placeholder}
          readOnly={readOnly}
          ref={
            register
              ? register({
                  required,
                  max,
                  maxLength,
                  min,
                  minLength,
                  validate: (v: string) =>
                    customValidation && customValidation(v),
                })
              : ref
          }
          small={small}
          step={step}
          type={type}
          {...props}
        />
        {measurement && <Measurement>{measurement}</Measurement>}
      </Wrapper>
    );
  }
);

Input.displayName = 'Input';
export default Input;
